import { FormControl, FormControlLabel, FormHelperText, Switch } from "@mui/material"
import { checkTouched, isTouched as hasBeenTouched } from "form/tools/validation"
import { Field, FieldProps } from "formik"
import React from "react"

interface IFieldCheckboxProps {
  fieldName: string // ex: "main.order_id"
  label: string
  disabled?: boolean
  isReadOnly?: boolean
  value: boolean
  error?: string
  toTouchFieldName?: string
  onSwitchClick?: (...args: any) => any // used for preview only
  onLabelClick?: (...args: any) => any // used for preview only
}

export const FieldCheckbox = React.memo(
  ({
    fieldName,
    label,
    disabled,
    isReadOnly,
    value,
    error,
    toTouchFieldName,
    onSwitchClick,
    onLabelClick
  }: IFieldCheckboxProps) => (
    <Field name={fieldName}>
      {({ form: { touched, setFieldValue } }: FieldProps) => {
        const isTouched: boolean = hasBeenTouched(touched, fieldName)
        const isDisabled: boolean = disabled || Boolean(isReadOnly)
        const hasError = isTouched ? error !== undefined && error !== "" : false
        return (
          <FormControl id={fieldName} error={hasError} sx={{ "& .MuiFormControlLabel-label": { fontSize: ".8rem" } }}>
            <FormControlLabel
              control={
                <Switch
                  id={`${fieldName}-text-field`}
                  name={fieldName}
                  checked={value}
                  value={value}
                  onChange={(_event, checked) => {
                    checkTouched(touched, fieldName)
                    if (toTouchFieldName) {
                      checkTouched(touched, toTouchFieldName)
                    }
                    setFieldValue(fieldName, checked)
                  }}
                  onBlur={() => {
                    if (!isTouched) {
                      checkTouched(touched, fieldName)
                      if (toTouchFieldName) {
                        checkTouched(touched, toTouchFieldName)
                      }
                      setFieldValue(fieldName, value)
                    }
                  }}
                  disabled={isDisabled}
                  onClick={onSwitchClick}
                />
              }
              label={label}
              onClick={onLabelClick}
            />
            {hasError && <FormHelperText id={`${fieldName}-error`}>{error}</FormHelperText>}
          </FormControl>
        )
      }}
    </Field>
  )
)
